<template>
  <div class="realizations">
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"/>

    <div 
      v-for="(category, index) of realizationsCategories"
      :key="index"
      class="realizations__category">
        <h3 
          :style="`background-image: url(${backgroundTitle})`"
          class="realizations__category_title">
          {{ category.fields.title }}
        </h3>
        <RealizationsSwiper 
          :realizations="category.fields.realizations"
          @zoom="$_zoomRealization"
        />
    </div>

    <ZoomRealization 
      :realization="zoomRealization"
      @close="$_closeRealization"
    />
    
    <InternalNextPages :services="true" :company="true" />
    <FooterArea/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import HeroText from '@/components/HeroText/HeroText.vue'
import RealizationsSwiper from '@/components/RealizationsSwiper/RealizationsSwiper.vue'
import InternalNextPages from '@/components/InternalNextPages/InternalNextPages.vue'
import ZoomRealization from '@/components/ZoomRealization/ZoomRealization.vue'
import FooterArea from '@/components/FooterArea/FooterArea.vue'

export default {
  name: 'Quality',
  components: {
    HeroText,
    RealizationsSwiper,
    InternalNextPages,
    ZoomRealization,
    FooterArea
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    loading: true,
    zoomRealization: undefined,
    backgroundTitle: require('@/assets/pennellata-titolo.png'),
  }),
  computed: {
    ...mapGetters('contentful', [
      'realizationsCategories'
    ])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful',
      ['loadBlogPosts', 'loadRealizationsCategories']
    ),
    $_zoomRealization (realization) {
      this.zoomRealization = realization
    },
    $_closeRealization () {
      this.zoomRealization = undefined
    },
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadRealizationsCategories()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }

}
</script>

<style lang="scss">
  @import './../../assets/scss/typo.scss';
  @import './../../assets/scss/breakpoint.scss';

  .realizations{
    background-color: #f2fef1;
    @include site-paddings;

    .realizations__category{
      margin: 0 0 5rem;
      @include media(">=large"){
        margin: 2rem 0 7rem;
      }
      .realizations__category_title{
        @include text-hero($color: #000000);
        display: block;
        margin: 4rem 0 2.5rem;
        font-weight: 700;
        text-align: center;
        padding: 2rem 0;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
  }
</style>
